import { withNavBar } from "../../shared/NavBar/NavBar";
import sharedHistory from "../../../shared/History";
import { RouteNames } from "../../../shared/enums/RouteNames";
import "./ForgotPasswordSuccess.scss";
import useLocalization from "../../../shared/useLocalization/useLocalization";
import { getQuery } from "../../../shared/pageUtilities/pageUtilities";

const ForgotPasswordSuccess = () => {
  const doneClicked = () => {
    sharedHistory.push(
      `${RouteNames.ForgotPasswordCode}?u=${getQuery().get("u") || ""}`
    );
  };

  const local = useLocalization();

  if (!local) return <></>;

  const pageText: string[] = local.t("forgotPasswordSuccess.text") as any;
  return (
    <>
      <h4 className="main_title" data-testid="mainTitle">
        {local.t("createAccountSuccessPage.title")}
      </h4>
      <div className="row">
        <div className="col m9 s12">
          <h3 className="center valign-wrapper">
            <i className="medium material-icons success">check</i>
            {local.t("forgotPasswordSuccess.subTitle")}
          </h3>
        </div>
        <div className="col m3 s12">
          <button
            className="btn btn-primary"
            data-testid="doneButton"
            onClick={doneClicked}
          >
            {local.t("forgotPasswordSuccess.doneButtonText")}
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col s12 font-weight-bold">
          {pageText[0]} 
        </div>
      </div>
      <div className="row">
        <div className="col s12 font-weight-bold">{getQuery().get("u")}</div>
      </div>
      <div className="row">
        <div className="col s12">{pageText[1]}</div>
      </div>
    </>
  );
};

export default withNavBar(ForgotPasswordSuccess);
